import React, { useState } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";

export default function PayrollItems() {
  const [activeTab, setActiveTab] = useState("additions");

  const payrollItems = [
    {
      name: "Leave balance amount",
      category: "Monthly remuneration",
      amount: 400,
    },
    {
      name: "Arrears of salary",
      category: "Additional remuneration",
      amount: 1200,
    },
    {
      name: "Gratuity",
      category: "Monthly remuneration",
      amount: 1000,
    },
    {
      name: "HRA",
      category: "Monthly remuneration",
      amount: 12000,
    },
  ];

  return (
    <div className="  mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3  ">
        <h5 className="fw-bold">Payroll Items</h5>
        <button className="btn btn-primary">+ Add Addition</button>
      </div>

      {/* Tabs */}
      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "additions" ? "active" : ""}`}
            onClick={() => setActiveTab("additions")}
          >
            Additions
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "deductions" ? "active" : ""}`}
            onClick={() => setActiveTab("deductions")}
          >
            Deductions
          </button>
        </li>
      </ul>

      {/* Table */}
      <div className="table-responsive">
        <table className="table table-bordered align-middle text-center">
          <thead className="table-light text-uppercase">
            <tr>
              <th>Name</th>
              <th>Category</th>
              <th>Default/Unit Amount</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {payrollItems.map((item, idx) => (
              <tr key={idx}>
                <td>{item.name}</td>
                <td>{item.category}</td>
                <td>₹{item.amount}</td>
                <td>
                  <button className="btn btn-sm btn-outline-primary me-2">
                    <FaEdit />
                  </button>
                  <button className="btn btn-sm btn-outline-danger">
                    <FaTrash />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination placeholder */}
      <div className="d-flex justify-content-end mt-3">
        <p className="text-muted">
          Rows per page: 12 &nbsp;&nbsp; 1–12 of 276 &nbsp;&lt; &gt;
        </p>
      </div>
    </div>
  );
}
